import { useDispatch } from 'react-redux';

import { log } from '@app/shared/utils/logger';
import { clearCachedInitData } from '@app/shared/utils/common';
import { useLogoutMutation } from '@/app/store/slices/auth/authApi';
import { logout as logoutAction } from '@/app/store/slices/auth/authSlice';

export const useLogout = () => {
  const dispatch = useDispatch();
  const [logoutApi, { isLoading }] = useLogoutMutation();

  const handleLogout = async () => {
    try {
      await logoutApi().unwrap();
    } catch (error: unknown) {
      void log({ level: 'error', message: 'logout error', error });
    } finally {
      clearCachedInitData();
      dispatch(logoutAction());
    }
  };

  return {
    handleLogout,
    isLoading,
  };
};
